<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      :title="'Historique des arrangements du mandat ' + id"
      subtitle="Recherche des arrangements"
      bdTable="arrangements"
      :parameters="{ warrant_id : id }"
      :actions="actions"
      :fields="fields"
      :Api="Api"
    >
     
      <template v-slot:cell(ID)="data">
        <b-link :to="{ name: 'settlement', params: { id: data.item.ID } }">
          {{ data.item.ID }}
        </b-link>
      </template>
     
    </bd-table-list>
 
    
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import DateTime from "@/services/DateTime.js";
import settlements from "@/services/settlements.js";
export default {
  name: "Settlements",
  components: {
    BdTableList,
  },
  props: {
    id: Boolean
  },
  data() {
    return {
      Api: settlements,
      busy: false,
      busy_confirm: false,
    
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats",
          to: { name: "warrants" },
        },
        {
          text: "Mandat n° " + this.$props.id,
          to: { name: "warrantView", params: this.$props.id },
        },
        {
          text: "Arrangements",
          active: true,
        },
      ],
      actions: [
        {
          label: "Visualiser",
          to: "settlement",
          icon: "pencil-square",
          variant: "success"
        },
      ],
      fields: [
       {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },

        {
          key: "date",
          label: "Date",
          sortable: true,
          formatter: (value) => this.toDate(value)
        },
        {
          key: "date_end",
          label: "Date de fin",
          sortable: true,
          formatter: (value) => this.toDate(value)
        },

        {
          key: "status",
          label: "Status",
          class: "text-center",
          sortable: true,
          formatter: (value) => {
            switch(value) {
              case 'proposal':
                return 'Proposition'
              case 'breached':
                return 'Non respecté';
              case 'confirmed':
                return 'Confirmé'
              case 'stopped':
                return 'Arrếté'
              case 'adjusted':
                return 'Ajusté';
              case 'finished':
                return 'Terminé'
            }
            
          }
        },
        {
          key: "initiative",
          label: "Initiative",
          class: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
  methods: {
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
   
  
    toDate(d) {
      return DateTime.humanDate(d);
    },
     
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>